import { Stack } from "@mui/material";
import { Typography } from "@eventr/common-storybook";
import { getValue } from "../../utils";
import { TextTypography } from "./text";
interface ISimpleFromToTimesProps {
  data: any;
  renderOptions: ISimpleFromToTimesOptions;
}
interface ISimpleFromToTimesOptions {
  fromTime: string;
  toTime: string;
  typography: TextTypography;
}
export const SimpleFromToTimes = ({ data, renderOptions }: ISimpleFromToTimesProps) => {
  return (
    <Stack direction="row" sx={{
      justifyContent: "space-between"
    }}>
      <Typography variant={renderOptions.typography ?? "bodyRegular"}>
        {getValue(data[renderOptions.fromTime])}
      </Typography>
      <Typography variant={renderOptions.typography ?? "bodyRegular"} sx={{
        padding: "0px 4px"
      }}>
        {"-"}
      </Typography>
      <Typography variant={renderOptions.typography ?? "bodyRegular"}>
        {getValue(data[renderOptions.toTime])}
      </Typography>
    </Stack>
  );
};
